import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Box, CircularProgress } from '@mui/material';

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  /** Function that receives the current user and returns true if access is allowed */
  check: (user: any) => boolean;
  /** Where to redirect if access is denied (defaults to /) */
  redirectTo?: string;
}

/**
 * Route wrapper that checks role-based permissions.
 * Must be used inside a <ProtectedRoute> (authentication is already handled).
 */
const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({
  children,
  check,
  redirectTo = '/',
}) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (!check(user)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default RoleProtectedRoute;
